export const SUI_ICON_COLOR = '#0D8EEB';
